import { Calendar } from '@good/icons';
import { Avatar } from '@good/ui/core';
import { Text } from 'common-components/typography';
import React from 'react';

interface OpenSlotsDetailsColumnProps {
  numberOfSlots: number;
}

export const OpenSlotsDetailsColumn = ({ numberOfSlots }: OpenSlotsDetailsColumnProps) => {
  return (
    <div className='flex-row p-medium justify-between'>
      <div className='flex-row'>
        <Avatar radius='md' mr='sm'>
          <Calendar />
        </Avatar>
        <div className='flex-column line-height-135'>
          <Text lineHeight={120}>Open slots</Text>
          <Text size='regular' color='secondary' lineHeight={135}>
            {numberOfSlots} slots
          </Text>
        </div>
      </div>
    </div>
  );
};
